<template>
	<div class="left-nav-wrap" @mouseleave="closeFlyout">
		<!-- 品牌区已移除（2026-10-09 许工要求）：
		     原「六 / 六彩视界」标题改由顶栏承担，这里只留菜单本体，
		     底部固定一行：版本信息（左） + 折叠按钮（右）。 -->

		<!-- ============ 展开态：标准 el-submenu ============ -->
		<el-menu
			v-if="!collapsed"
			collapse-transition
			router
			:default-active="$route.path"
			unique-opened
			class="left-nav"
			:background-color="menuBg"
			:text-color="menuText"
			color="#ffffff"
			:active-text-color="menuActive"
		>
			<el-menu-item v-if="admin" :index="MainIndexUrl" @click="clickMainMenu">
				<i class="el-icon-house"></i>
				<template #title><span>系统门户</span></template>
			</el-menu-item>
			<el-submenu v-for="menu in listData" :key="menu.keyId" :index="menu.menuName">
				<template #title>
					<i :class="menu.menuIcon"></i>
					<span>{{ menu.menuName }}</span>
				</template>
				<el-menu-item-group>
					<el-menu-item
						v-for="chmenu in menu.subList"
						:key="chmenu.keyId"
						:index="normalizePath(chmenu)"
						@click="clickMyMenu(chmenu)"
					>
						<template><i :class="chmenu.menuIcon"></i><span>{{ chmenu.menuName }}</span></template>
					</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
		</el-menu>

		<!-- ============ 折叠态：图标 + 文字提示 + 二级浮层（JS 控制显隐） ============ -->
		<div v-else class="left-nav left-nav--collapsed">
			<div v-if="admin" class="nav-icon" @click="clickMainMenu" title="系统门户">
				<i class="el-icon-house"></i>
				<span class="nav-icon__tip">系统门户</span>
			</div>

			<div
				v-for="menu in listData"
				:key="'c_' + menu.keyId"
				class="nav-icon"
				:class="{ 'is-open': flyoutKey === menu.keyId }"
				@click="toggleFlyout(menu)"
				@mouseenter="hoverFlyout(menu)"
			>
				<i :class="menu.menuIcon"></i>
				<!-- 一级菜单文字提示（鼠标移入显示） -->
				<span class="nav-icon__tip">{{ menu.menuName }}</span>

				<!-- 二级菜单浮层 -->
				<div v-show="flyoutKey === menu.keyId" class="flyout" @click.stop>
					<div class="flyout__title">
						<i :class="menu.menuIcon"></i>
						<span>{{ menu.menuName }}</span>
					</div>
					<div class="flyout__list">
						<div
							v-for="chmenu in menu.subList"
							:key="'s_' + chmenu.keyId"
							class="flyout__item"
							:class="{ 'is-active': isActive(chmenu) }"
							@click.stop="handleFlyoutClick(chmenu)"
						>
							<i :class="chmenu.menuIcon"></i>
							<span>{{ chmenu.menuName }}</span>
						</div>
						<div v-if="!menu.subList || !menu.subList.length" class="flyout__empty">暂无子菜单</div>
					</div>
				</div>
			</div>
		</div>

		<!-- ============ 底栏：版本信息（左） + 折叠按钮（右） ============ -->
		<div class="left-foot">
			<span class="left-foot__ver" :title="verTitle">{{ verShort }}</span>
			<button
				class="left-foot__toggle"
				:title="collapsed ? '展开菜单' : '收起菜单'"
				:aria-label="collapsed ? '展开菜单' : '收起菜单'"
				@click="toggleCollapsed"
			>
				<i :class="collapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
			</button>
		</div>
	</div>
</template>

<script>
import { GetRoleMenuTreeList } from "../../api/menuApi.js";
import { MyDebounce } from "../../utils/util.js";

const STORAGE_KEY = "lcsj-menu-collapsed";

export default {
	name: "Leftnav",
	data() {
		return {
			admin: false,
			loginName: "",
			collapsed: readStore(),
			allmenu: [],
			listData: [],
			MainIndexUrl: "",
			// 当前展开浮层的一级菜单 key；null 表示都收起
			flyoutKey: null,
			// 侧栏配色走设计 token，与新主题体系一致
			menuBg: "var(--app-sidebar-bg)",
			menuText: "var(--app-sidebar-text)",
			menuActive: "var(--app-sidebar-active)"
		};
	},
	created() {
		this.getRoleMenuTree();
		const that = this;
		that.loginName = JSON.parse(localStorage.getItem("userdata"));
		let userdata = that.loginName;
		if (userdata.roleInfo.keyId == "2f91e757a9c4444dbe13146a363a717c") {
			that.admin = true;
		}
		// 折叠事件：来自顶部栏 lcsj-menu-toggle（沿用原有 Bus 通信方式）
		that.$root.Bus.$on("toggle", (value) => {
			that.collapsed = !!value;
			that.flyoutKey = null;
			writeStore(!!value);
		});
	},
	computed: {
		/** 版本号：取 package.json 的 version，避免两处维护不一致 */
		verText() {
			return "v" + (process.env.VUE_APP_VERSION || "");
		},
		/** 折叠时空间有限，只留主版本号 */
		verShort() {
			return this.collapsed ? "v" + (process.env.VUE_APP_VERSION || "").split(".")[0] : this.verText;
		},
		verTitle() {
			return this.collapsed ? this.verText : "";
		}
	},
	methods: {
		/** 底栏折叠按钮：与顶栏按钮共用 Bus 通道（exeIndex / TitleBar 都在监听） */
		toggleCollapsed() {
			const next = !this.collapsed;
			this.collapsed = next;
			this.flyoutKey = null;
			writeStore(next);
			if (this.$root.Bus) {
				this.$root.Bus.$emit("toggle", next, next);
			}
		},
		normalizePath(menu) {
			return menu.menuPath.startsWith("/") ? menu.menuPath : "/" + menu.menuPath;
		},
		isActive(menu) {
			return this.$route.path === this.normalizePath(menu);
		},
		handleBrandClick() {
			if (this.$route.path !== "/exeIndex/mainIndex/workbench") {
				this.$router.push({ path: "/exeIndex/mainIndex/workbench" });
			}
		},
		/** 鼠标移入即展开对应浮层 */
		hoverFlyout(menu) {
			if (this.flyoutKey !== menu.keyId) {
				this.flyoutKey = menu.keyId;
			}
		},
		/** 点击图标切换浮层（触屏/点击场景） */
		toggleFlyout(menu) {
			this.flyoutKey = this.flyoutKey === menu.keyId ? null : menu.keyId;
		},
		closeFlyout() {
			this.flyoutKey = null;
		},
		/** 折叠态点击二级菜单：先自动展开侧栏，再跳转 */
		handleFlyoutClick: MyDebounce(function (menu) {
			this.flyoutKey = null;
			this.collapsed = false;
			writeStore(false);
			if (this.$root.Bus) {
				this.$root.Bus.$emit("toggle", false, false);
			}
			this.clickMyMenu(menu);
		}, 200),
		// 点击菜单 - 添加防抖处理
		clickMyMenu: MyDebounce(function (menu) {
			if (menu.keyId == "1") {
				if (this.$refs.menuEdit) this.$refs.menuEdit.editShow();
			} else {
				this.$router.push({ path: this.normalizePath(menu) });
			}
		}, 300),
		getRoleMenuTree() {
			let userInfo = JSON.parse(localStorage.getItem("userdata"));
			GetRoleMenuTreeList({ keyId: userInfo.roleInfo.keyId, menuType: 1 }).then((res) => {
				if (res.code == 1) {
					this.listData = res.data || [];
				}
			});
		},
		// 点击主菜单 - 添加防抖处理
		clickMainMenu: MyDebounce(function () {
			this.$router.push({ path: "/exeIndex/mainIndex/workbench" });
		}, 300)
	}
};

/* ---- 折叠状态持久化（与 lcsjMenuToggle 共用同一 key） ---- */
function readStore() {
	try {
		return window.localStorage.getItem(STORAGE_KEY) === "1";
	} catch (e) {
		return false;
	}
}
function writeStore(v) {
	try {
		window.localStorage.setItem(STORAGE_KEY, v ? "1" : "0");
	} catch (e) {
		/* 静默降级 */
	}
}
</script>

<style scoped>
.left-nav-wrap {
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

/* ========== 底栏：版本信息（左） + 折叠按钮（右） ========== */
.left-foot {
	margin-top: auto; /* flex column 容器里靠 auto 顶到底部 */
	height: 40px;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: flex-end; /* 整体靠右 */
	gap: 6px;
	padding: 0 8px;
	border-top: 1px solid rgba(255, 255, 255, 0.08);
	background: rgba(0, 0, 0, 0.12);
}
.left-foot__ver {
	flex: 1;
	min-width: 0;
	color: rgba(255, 255, 255, 0.45);
	font-size: 11px;
	line-height: 1;
	text-align: left;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.left-foot__toggle {
	width: 28px;
	height: 28px;
	flex-shrink: 0;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	border: none;
	border-radius: 6px;
	background: transparent;
	color: rgba(255, 255, 255, 0.75);
	font-size: 16px;
	cursor: pointer;
	transition: background-color 0.2s ease, color 0.2s ease;
}
.left-foot__toggle:hover {
	background: rgba(255, 255, 255, 0.14);
	color: #fff;
}
.left-foot__toggle:active {
	background: rgba(255, 255, 255, 0.22);
}

/* ========== 展开态菜单 ========== */
.left-nav {
	flex: 1;
	border: none;
	overflow-y: auto;
	overflow-x: hidden;
	scrollbar-width: none;
	-ms-overflow-style: none;
}
.left-nav::-webkit-scrollbar {
	width: 0;
	height: 0;
}

.el-menu-item-group__title {
	padding: 0 !important;
	display: none;
}
.el-submenu__title i,
.left-nav .el-menu-item i {
	color: rgba(255, 255, 255, 0.85) !important;
}
.el-submenu__title:hover i,
.left-nav .el-menu-item:hover i {
	color: #fff !important;
}
.left-nav .el-menu-item.is-active i {
	color: inherit !important;
}

/* ========== 折叠态 ========== */
.left-nav--collapsed {
	overflow-y: auto;
	overflow-x: visible; /* 允许浮层溢出 */
	scrollbar-width: none;
}
.left-nav--collapsed::-webkit-scrollbar {
	width: 0;
	height: 0;
}

.nav-icon {
	position: relative;
	height: 46px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: rgba(255, 255, 255, 0.85);
	font-size: 17px;
	cursor: pointer;
	transition: background 0.15s, color 0.15s;
}
.nav-icon:hover,
.nav-icon.is-open {
	background: rgba(255, 255, 255, 0.1);
	color: #fff;
}

/* 一级菜单文字提示：hover 显示在图标右侧 */
.nav-icon__tip {
	position: absolute;
	left: 100%;
	top: 50%;
	transform: translateY(-50%);
	margin-left: 8px;
	padding: 5px 10px;
	background: var(--app-text);
	color: var(--app-surface);
	font-size: var(--app-font-sm);
	border-radius: var(--app-radius-sm);
	white-space: nowrap;
	opacity: 0;
	visibility: hidden;
	transition: opacity 0.14s, visibility 0.14s;
	z-index: 3001;
	pointer-events: none;
}
.nav-icon:hover .nav-icon__tip {
	opacity: 1;
	visibility: visible;
}

/* ========== 二级菜单浮层 ========== */
.flyout {
	position: fixed;
	left: 64px; /* 与折叠态侧栏宽度一致 */
	min-width: 176px;
	max-width: 260px;
	background: var(--app-surface);
	border: 1px solid var(--app-border);
	border-radius: var(--app-radius);
	box-shadow: var(--app-shadow-lg);
	overflow: hidden;
	z-index: 3002;
}
.flyout__title {
	display: flex;
	align-items: center;
	gap: 7px;
	padding: 9px 14px;
	font-size: var(--app-font-base);
	font-weight: 600;
	color: var(--app-text);
	background: var(--app-surface-muted);
	border-bottom: 1px solid var(--app-border);
	white-space: nowrap;
}
.flyout__title i {
	color: var(--app-primary-text);
	font-size: 14px;
}
.flyout__list {
	max-height: 60vh;
	overflow-y: auto;
	padding: 4px 0;
}
.flyout__item {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 8px 14px;
	font-size: var(--app-font-base);
	color: var(--app-text-secondary);
	cursor: pointer;
	white-space: nowrap;
	transition: background 0.12s, color 0.12s;
}
.flyout__item i {
	color: var(--app-text-muted);
	font-size: 13px;
	flex-shrink: 0;
}
.flyout__item:hover {
	background: var(--app-primary-soft);
	color: var(--app-primary-text);
}
.flyout__item:hover i {
	color: var(--app-primary-text);
}
.flyout__item.is-active {
	background: var(--app-primary);
	color: var(--app-text-inverse);
	font-weight: 600;
}
.flyout__item.is-active i {
	color: var(--app-text-inverse);
}
.flyout__empty {
	padding: 14px;
	font-size: var(--app-font-base);
	color: var(--app-text-muted);
	text-align: center;
}
</style>